import { useEffect } from 'react';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import BenefitCard from '../../components/BenefitCard';

function BenefitsAndPerks(props) {
  const { company, postContainerRef, showPerksAndBenefits } = props;
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  useEffect(() => {
    if (showPerksAndBenefits && postContainerRef.current) {
      postContainerRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [showPerksAndBenefits]);

  return (
    <Box
      sx={{
        minHeight: company?.benefits?.length > 0 ? 'calc(100vh - 50px)' : '0px',
        overflowY: 'auto',
        backgroundColor: '#f4f8ff',
        maxWidth: isSM ? 'calc(100vw - 30px)' : 'calc(100vw - 80px)',
      }}
    >
      <Typography
        sx={{
          mt: '20px',
          color: '#001030',
          fontWeight: '600',
          fontSize: '20px',
          lineHeight: '130%',
        }}
      >
        Perks & Benefits for Advisory Board Members
      </Typography>
      <Typography
        sx={{
          mt: '10px',
          mb: '20px',
          color: '#4D586F',
          fontWeight: '400',
          fontSize: '14px',
          fontStyle: 'italic',
          lineHeight: '150%',
        }}
      >
        The advisory board will provide periodic updates to its perks &
        benefits, which will appear in Boardroom Activity.
      </Typography>

      {company.benefits && (
        <Grid container spacing={2}>
          {company.benefits.map((benefit, index) => (
            <Grid item key={index} xxs={12} xs={6} sm={4} md={3}>
              <BenefitCard
                benefit={benefit}
                categoryStyle={{ color: '#001030' }}
                detailStyle={{ color: '#001030', fontSize: '16px' }}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}

export default BenefitsAndPerks;
